import {useEffect, useRef} from 'react';
import {MAX_TIMEOUT_WAIT_IN_MS} from '../../../features/constants/constants';
import {useGetCoins} from '../utils/useGetCoins';

export const CoinsRefresh: React.FC = () => {
  const {data, refetch} = useGetCoins();

  const now = new Date().getTime();
  const timeout = useRef<NodeJS.Timeout>(undefined);
  const nextUpdate =
    data?.availability?.$case === 'available' &&
    data.availability.available.nextUpdate
      ? new Date(data.availability.available.nextUpdate).getTime()
      : undefined;

  useEffect(() => {
    if (!nextUpdate) {
      return;
    }

    const diff = nextUpdate - now;

    timeout.current = setTimeout(() => {
      refetch();
    }, Math.min(diff, MAX_TIMEOUT_WAIT_IN_MS));

    return () => timeout.current && clearTimeout(timeout.current);
  }, [nextUpdate]);

  return null;
};
